import { render, staticRenderFns } from "./QEditCustomer.vue?vue&type=template&id=968da472&"
import script from "./QEditCustomer.vue?vue&type=script&lang=js&"
export * from "./QEditCustomer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports